import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import { useAppSelector } from "soapbox/hooks";
import { isStandalone } from "soapbox/utils/state";
import classNames from "classnames";
import { useTheme } from "soapbox/hooks";

import AboutPage from "../about";
import LandingPage from "../landing_page";
import MobilePage from "../mobile";

import Footer from "./components/footer";
import Header from "./components/header";

const PublicLayout = () => {
  const standalone = useAppSelector((state) => isStandalone(state));
  const darkMode = useTheme() === "dark";

  if (standalone) {
    return <Redirect to="/login/external" />;
  }

  return (
    <div
      className={classNames(
        "h-full",
        darkMode ? "bg-[#0e1925]" : "bg-[#f0f0f0]",
      )}
    >
      <div className="flex flex-col h-screen">
        <div className="flex-shrink-0">
          <Header />

          <div className="relative">
            <Switch>
              <Route exact path="/" component={LandingPage} />
              <Route exact path="/about/:slug?" component={AboutPage} />
              <Route exact path="/mobile/:slug?" component={MobilePage} />
            </Switch>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default PublicLayout;
